import { Component, OnInit } from "@angular/core";

export interface Configuraciones {
  nombre?: string;
  description?: string;
  url?: string;
  icon?: string;
}

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  constructor() {}

  listadoDeConfiguraciones: Configuraciones[] = [
    {
      nombre: "Mi Empresa",
      description: "Carga y edita los datos fiscales y de contacto de tu negocio.",
      url: "/configurar/empresa",
    },
    {
      nombre: "Colaboradores",
      description: "Gestiona los usuarios que acceden al sistema y define sus permisos y roles.",
      url: "/configurar/colaboradores",
    },
    {
      nombre: "Almacenes y Depósitos",
      description: "Gestiona tus depósitos y sucursales para controlar el stock en cada ubicación.",
      url: "/configurar/almacenes"
    },
    {
      nombre: "Rubros",
      description: "Clasifica tus productos en categorías para una mejor gestión y reportería.",
      url: "/configurar/rubros",
    },
    {
      nombre: "Marcas",
      description: "Organiza tu catálogo de productos creando las marcas que comercializas.",
      url: "/configurar/marcas",
    },
    {
      nombre: "Puntos de venta",
      description: "Crea los puntos de emisión para tus facturas, necesarios para cumplir con AFIP.",
      url: "/configurar/punto-venta",
    },
    {
      nombre: "Tipos de Comprobante",
      description: "Define los procesos internos del sistema (ej. Venta, Compra, Ajuste de Stock).",
      url: "/configurar/voucher-types"
    },
    {
      nombre: "Talonarios",
      description: "Configura los talonarios fiscales (A, B, C) e internos (X) que usarás para facturar.",
      url: "/configurar/talonarios",
    },
    {
      nombre: "Listas de precios",
      description: "Define diferentes políticas de precios para tus clientes (ej. Minorista, Mayorista).",
      url: "/configurar/lista-precio",
    },
    {
      nombre: "Tipo de Variantes",
      description: "Crea atributos para tus productos como Talle, Color o Material.",
      url: "/configurar/tipovariantes",
    },
    {
      nombre: "Tienda",
      description: "Configura los parámetros de tu e-commerce: medios de pago, envíos y más.",
      url: "/configurar/tienda",
    },
    {
      nombre: "Turnos",
      description: "Define los turnos de trabajo para la planificación y el control de la producción.",
      url: "/configurar/turnos"
    },
    {
      nombre: "Integraciones",
      description: "Gestiona las integraciones con servicios externos como pasarelas de pago, envíos, CRM y más.",
      url: "/configurar/integraciones"
    },

  ];

  ngOnInit(): void {
    const sidebar = <HTMLElement>document.querySelector(".navbar-brand");
    if (sidebar !== undefined) {
      sidebar.innerHTML = "Configuraciones";
    }
  }
}
